import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ChangeAvatarModule } from '@core/components/change-avatar/change-avatar.module';
import { ChangePasswordModule } from '@core/components/change-password/change-password.module';
import { DisclaimerModule } from '@core/components/disclaimer/disclaimer.module';
import { FuseSharedModule } from '@fuse/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { DialogArchiveOrUnarchiveUserModule } from '../dialog-archive-or-unarchive-user/dialog-archive-or-unarchive-user.module';
import { DialogUsersComponent } from './dialog-users.component';
import { TabGeneralModule } from './tabs/general/tab-general.module';
import { TabGroupModule } from './tabs/groups/tab-groups.module';
import { TabPreferencesModule } from './tabs/preferences/tab-preferences.module';

@NgModule({
  entryComponents: [
    DialogUsersComponent
  ],
  declarations: [
    DialogUsersComponent
  ],
  imports: [
    TranslateModule,

    FuseSharedModule,
    MatIconModule,
    MatTabsModule,
    MatButtonModule,
    MatToolbarModule,
    MatTooltipModule,

    TabGroupModule,
    TabGeneralModule,
    TabPreferencesModule,
    DisclaimerModule,
    ChangeAvatarModule,
    ChangePasswordModule,
    DialogArchiveOrUnarchiveUserModule
  ],
  exports: [
    DialogUsersComponent
  ]
})
export class DialogUsersModule { }
